import { Button, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Switch, Typography, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useTraslados } from '../../../hooks/useCases/useTraslados';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import { Note } from '@material-ui/icons';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import DeleteButtonAbm from '../../compartidos/abms/DeleteButtonAbm';
import { useFormNew } from '../../../hooks/useFormNew';

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

const useStyles = makeStyles({
    hoverNota: {
      "&:hover": {
        backgroundColor: "#80808026",
        cursor: "pointer",
      },
    },
    switchBase: {
        color: '#bdbdbd',
        '&$checked': {
          transform: 'translateX(16px)',
          color: '#4CAF50',
          '& + $track': {
            backgroundColor: '#3E8040',
            opacity: 1,
            border: 'none',
          },
        },
      },
      checked: {},
      track: {},
  });

const initModalNota = {
    open: false,
    nota: null
}

export const NotasTraslados = ({ formValues, disabled }) => {

    const classes = useStyles();
    const { data, remove } = useTraslados()
    const [modalNota, setModalNota] = useState(initModalNota)

    return (
    <>
        <Grid item xs={12}>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    setModalNota({open: true, nota: null});
                }}
                disabled={disabled}
            >
                + Agregar Nota
            </Button>
        </Grid>
        <Grid item xs={6} style={{ marginTop: '1.5em' }}>
        {Array.isArray(data.notasTraslado) && data.notasTraslado?.length > 0 ? (
            <List>
                {data.notasTraslado.map((nota) => (
                    <ListItem
                        key={nota.idNota}
                        className={classes.hoverNota}
                        onClick={() => setModalNota({open: true, nota: nota})}
                    >
                        <ListItemAvatar>
                            <Note
                                color={ nota.publica ? "primary" : "disabled" }
                            />
                        </ListItemAvatar>
                        <ListItemText
                            primary={ nota.publica ? "Pública" : "Privada" }
                            secondary={ new Date(nota.fechaCarga).toLocaleString(
                                "es",
                                optionsfecha
                            )}
                        />
                        <ListItemText
                            primary={ nota.usuario?.userName ? nota.usuario.userName : "Usuario No Registrado" }
                        />
                        <ListItemSecondaryAction>
                            <DeleteButtonAbm
                                mensajeEliminacion={"¿Desea Eliminar Esta Nota?"}
                                handleDelete={()=> remove.nota(nota.idNota, () => setModalNota(initModalNota))}
                                permiso={disabled ? true : null}
                            />
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
        ) : (
            <Typography
                style={{
                    fontSize: "1.1rem",
                    fontStyle: "italic",
                    marginBottom: "1rem",
                }}
            >
                No hay notas
            </Typography>
        )}
        </Grid>
        {
            modalNota.open && 
            <GenericModal
                open={modalNota.open}
                closeModal={() => setModalNota(initModalNota)}
                title={modalNota.nota ? "MODIFICAR NOTA" : "CREAR NUEVA NOTA"}
                maxWidth='sm'
            >
                <FormNuevaNota
                    nota={modalNota.nota}
                    idTraslado={formValues.idTraslado}
                    closeModal={() => setModalNota(initModalNota)}
                    disabled={disabled}
                />
            </GenericModal>
        }
    </>
  )
}

const FormNuevaNota = ({ nota, idTraslado, closeModal, disabled }) => {
    
    const classes = useStyles();
    const { post, put } = useTraslados()

    const initialValues = {
        idNota: nota?.idNota || "",
        nota: nota?.nota || "",
        idTraslado: idTraslado,
        publica: nota?.publica || false
    }
    const { formValues, setearValor } = useFormNew(initialValues)

    return (
      <ValidatorForm onSubmit={()=>{
        formValues.idNota !== '' ? put.nota(formValues, closeModal) : post.nota(formValues, closeModal)
      }}>
        <Grid container spacing={2}>
            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {
                    !disabled && 
                    <>
                        <Typography>Pública</Typography>
                        <Switch
                            checked={formValues.publica}
                            onChange={(event) => setearValor('publica', event.target.checked)}
                            name="publica"
                            color="primary"
                            classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                            disabled={disabled}
                        />
                    </>
                }
            </Grid>
            <Grid item xs={12}>
                <TextValidator
                    fullWidth
                    multiline
                    label="Nota"
                    value={formValues.nota}
                    onChange={(e) => setearValor('nota', e.target.value)}
                    validators={['required']}
                    errorMessages={['Agrege una descripción']}
                    disabled={disabled}
                />
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'right' }}>
                <Button type="submit" variant="contained" color="primary" disabled={disabled}>
                    Guardar
                </Button>
            </Grid>
        </Grid>
      </ValidatorForm>
    )
}
